<template>
    <BasicLayout :left='left' :middle='middle' :right='right'>
      <template v-slot:right_view>
        <div class='h100vh-100'>
          <WarnFilterTableButton @notice='notice'></WarnFilterTableButton>
          <WarnFilterTable ref='ruleTable'></WarnFilterTable>
        </div>
      </template>
    </BasicLayout>
  </template>
  
  <script>
  import BasicLayout from '../../layouts/BasicLayout';
  import WarnFilterTableButton from '../../components/alarmconfig/warnFilter/WarnFilterTableButton';
  import WarnFilterTable from '../../components/alarmconfig/warnFilter/WarnFilterTable';

  export default {
    name: 'WarnFilterPage',
    components: {
      BasicLayout,
      WarnFilterTableButton,
      WarnFilterTable
    },
    data() {
      return {
        left: {
          show: false,
          name: ''
        },
        middle: {
          show: false,
          name: ''
        },
        right: {
          show: true,
          crumb: `${this.$t('Alarm.alarmManage')}/${this.$t('Alarm.warnfilter')}`
        }
      };
    },
    methods: {
      notice(type) {
        switch (type) {
          case 'add':
            this.$refs.ruleTable.addFunc();
            break;
          case 'remove':
            this.$refs.ruleTable.removeFunc();
            break;
          case 'edit':
            this.$refs.ruleTable.editFunc();
            break;
          case 'refresh':
            this.$refs.ruleTable.getBlockingRuleData();
            break;
          case 'able':
            this.$refs.ruleTable.updateStatusFunc('enable');
            break;
          case 'disable':
            this.$refs.ruleTable.updateStatusFunc('unenable');
            break;
          default:
        }
      }
    }
  };
  </script>